export default __webpack_public_path__ + "static/media/RemolqueDoble VIP6.4975c65d.png";